import { FC } from 'react';
import styled from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
//import { ShopIcon, MedalIcon, CardIcon, WrenchIcon, GiftIcon2, ShareIcon, ShakeHands, Coupon2 } from '@/components/UI/svg/Referral';
import ShopIcon from '@/components/UI/svg/Referral/Icon/ShopIcon';
import MedalIcon from '@/components/UI/svg/Referral/Icon/MedalIcon';
import CardIcon from '@/components/UI/svg/Referral/Icon/CardIcon';
import WrenchIcon from '@/components/UI/svg/Referral/Icon/WrenchIcon';
import GiftIcon2 from '@/components/UI/svg/Referral/Icon/GiftIcon2';
import ShareIcon from '@/components/UI/svg/Referral/Icon/ShareIcon';
import ShakeHands from '@/components/UI/svg/Referral/Icon/ShakeHands';
import Coupon2 from '@/components/UI/svg/Referral/Icon/Coupon2';
import { Button } from '@/components/UI';

const Benefits: FC = ({}) => {
    const { useLang, useRouter, Link } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('referral');
    const arr = [
        {
            icon: <ShopIcon />,
            text: t('benefits.icon1'),
        },
        {
            icon: <Coupon2 />,
            text: t('benefits.icon2'),
        },
        {
            icon: <CardIcon />,
            text: t('benefits.icon3'),
        },
        {
            icon: <GiftIcon2 />, //<PhoneIcon />,
            text: t('benefits.icon4'),
        },
        {
            icon: <WrenchIcon />,
            text: t('benefits.icon5'),
        },
        {
            icon: <MedalIcon />, //<GiftIcon2 />,
            text: t('benefits.icon6'),
        },
        {
            icon: <ShareIcon />,
            text: t('benefits.icon7'),
        },
        {
            icon: <ShakeHands />,
            text: t('benefits.icon8'),
        },
    ];

    if (locale === 'kr') arr.pop();

    if (locale === 'jp') {
        arr.splice(1, 1);
        arr.splice(3, 1);
    }

    return (
        <div className={`${styled.benefits}`}>
            <h3 className="title">{t('benefits.title')}</h3>
            <Link href={`/${locale}/ecocredits`}>
                <Button className="refer-btn white" aria-label={t('benefits.btn')}>
                    {t('benefits.btn')}
                </Button>
            </Link>
            <ul className="icon_box">
                {arr &&
                    arr.map((item) => (
                        <div key={item.text} className="icon_item">
                            <div className="icon">{item.icon}</div>
                            <div className="text">{item.text}</div>
                        </div>
                    ))}
            </ul>
        </div>
    );
};

export default Benefits;
